<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>我的课程</p>
    </div>
    <div class="panel-content center_content">
      <ul
        id="list"
        class="list"
        v-if="tableData.length"
      >
        <li
          v-for="(item,index) in tableData"
          :key="index"
        >
          <div class="pic-wrap">
            <img
              :src="item.lessonOnline.logoPath?item.lessonOnline.logoPath:''"
              :onerror="$store.state.defaultImg"
              alt=""
            >
          </div>
          <div class="desc-wrap">
            <div class="desc-wrap-title">
              <p class="p1">{{item.lessonOnline.title?item.lessonOnline.title:'--'}}</p>
              <p class="p2">
                <span>负责人：{{item.lessonOnline.manager?item.lessonOnline.manager.name:'--'}}</span>
              </p>
            </div>
            <p class="text-intro">
              {{item.lessonOnline.brief?item.lessonOnline.brief:'简介：--'}}
            </p>
            <div class="progress-time">
              <div class="progress-bg">
                <div
                  class="skills progress"
                  :style="`width:${item.currentWeek/item.lessonOnline.allTime*100}%`"
                ></div>
              </div>
              <div>{{item.currentWeek}}/{{item.lessonOnline.allTime?item.lessonOnline.allTime:'--'}}周</div>
            </div>

            <div class="btns-wrap">
              <router-link
                :to="`/my/lesson/detail?id=${item.lessonOnline_id}&studentId=${item.id}`"
                class="btnOk btn-green"
              >进入课程</router-link>
              <a
                class="btnOk btn-yellow"
                href="javascript:;"
                @click="askDel(item)"
              >退出课程</a>
              <a
                class="btnOk btn-orange"
                href="javascript:;"
                @click="getStudentGrade(item)"
              >查看成绩</a>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="noitems"
        v-else
      >没有数据</div>
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      id="c-panel"
      :style="classShowGradeWindow"
    >
      <div id="c-panel-bg"></div>
      <div class="c-content">

        <form
          id="search"
          onsubmit="return false;"
        >
          <span
            class="close-cpanel"
            @click="hideGradeWindow"
          ></span>
        </form>
        <div id="uList">
          <table>
            <tbody>
              <tr class="l_header">
                <th>名称</th>
                <th>学习情况</th>
              </tr>
              <tr class="item">
                <td>预习</td>
                <td>{{getCount(studyProcessData.preview).toFixed(2)}}%（进度）</td>
              </tr>
              <tr class="item">
                <td>学习</td>
                <td>{{getCount(studyProcessData.study).toFixed(2)}}%（进度）</td>
              </tr>
              <tr class="item">
                <td>测试</td>
                <td>{{studyProcessData.exam.length?studyProcessData.exam[0].grade:'--'}}（分）</td>
              </tr>

            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import Pagination from '../../../components/Pager'
export default {
  name: 'MyLesson',
  components: {
    Pagination
  },
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        userProfile_id: this.$store.state.userInfo.profile_id,
        audit_status: 1,
        // lessonOnline_isPub: 1,
        lessonOnline_status: 5
      },
      tableData: [],
      tableDataCount: 0,
      nowTime: '',
      classShowGradeWindow: { visibility: 'hidden' },
      studentGradeList: {},
      studyProcessData: {
        preview: [],
        study: [],
        exam: []
      }
    }
  },
  // 函数方法
  methods: {
    getCount (item) {
      var sum = 0
      if (item) {
        for (let i = 0; i < item.length; i++) {
          sum = sum + item[i].finished
        }
        return item.length ? (sum / item.length).toFixed(2) * 100 : item.length
      } else {
        return 0
      }
    },
    formatGrade(value) {
      if (value < 60) {
        return '不及格'
      } else if (value >= 60 && value < 80) {
        return '及格'
      } else if (value >= 80 && value < 90) {
        return '良好'
      } else if (value >= 90 && value <= 100) {
        return '优秀'
      }
    },
    getWeek (dt) {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      _this.gettime = yy + '-' + mm + '-' + dd
      const d1 = new Date(dt) // 开始时间
      const d2 = new Date(_this.gettime) // 当前时间日期
      const rq = d2 - d1
      const days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      const num = Math.ceil(days / 7)
      return num
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.getOnlineStudent()
    },
    async getOnlineStudent() {
      await this.$http.get('/online_student/', {
        params: this.queryInfo
      }).then((data) => {
        for (let i = 0; i < data.results.length; i++) {
          data.results[i].currentWeek = data.results[i].lessonOnline.startTime ? this.getWeek(data.results[i].lessonOnline.startTime) : '--'
          data.results[i].lessonOnline.brief = data.results[i].lessonOnline.brief.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi)
        }
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    async askDel(item) {
      const url = '/online_student/' + item.id + '/'
      await this.$http.put(url, {
        isdel: 1
      }).then((data) => {
        this.getOnlineStudent()
        this.$layer.msg('退出成功!')
      }).catch((error) => {
        console.log(error)
      })
    },
    async getStudentGrade(item) {
      const url = '/online_student_study_process/'
      await this.$http.get(url, {
        params: {
          onlineStudentId: item.id
        }
      }).then((data) => {
        this.studyProcessData = data.data
      }).catch((error) => {
        console.log(error)
      })
      this.classShowGradeWindow = {
        visibility: 'visible'
      }
    },
    hideGradeWindow() {
      this.studentGradeList = {}
      this.classShowGradeWindow = {
        visibility: 'hidden'
      }
    }

  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }

  },
  mounted() {
    this.getOnlineStudent()
  }
}
</script>
<style scoped src="@/assets/css/project-detail.css"></style>
<style scoped lang="less">
// #panel {
//   min-width: 1350px;
// }
.list li {
  overflow: hidden;
  margin-bottom: 20px;
  padding: 20px 0;
  border-bottom: 2px solid #f1f5f5;
  box-sizing: border-box;
  .pic-wrap {
    width: 300px;
    height: 200px;
    float: left;
    position: relative;
    text-align: center;
    position: relative;
    overflow: hidden;

    .mark {
      position: absolute;
      left: 0;
      top: 0;
      height: 26px;
      line-height: 26px;
      padding: 0 10px;
      font-size: 12px;
      color: #fff;
      border-bottom-right-radius: 5px;
    }
    .mark0 {
      background: #eb6736;
    }
    .mark1 {
      background: #009999;
    }
    .mark2 {
      background: #ff9000;
    }
    img {
      max-width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      // vertical-align: middle;
      // object-fit: cover;
      // object-position: center;
    }
  }
  .desc-wrap {
    padding-left: 330px;
    font-size: 14px;
    color: #666;
    box-sizing: border-box;
    .desc-wrap-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .p1 {
      font-size: 18px;
      color: #000;
    }
    .p2 {
      color: #4a5d76;
      margin-left: 20px;
      span {
        color: #666;
        margin-right: 30px;
      }
    }
    .text-intro {
      width: 100%;
      margin-bottom: 10px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      color: #555;
      box-sizing: border-box;
      overflow: hidden;
      > span {
        color: #555;
        display: inline-block;
      }
    }
    .btns-wrap {
      margin-top: 10px;
      overflow: hidden;
      .btnOk {
        padding: 0 10px;
        height: 36px;
        line-height: 36px;
        border-radius: 5px;
        color: #fff;
        float: left;
        margin-right: 10px;
      }
      .btn-green {
        background: #25c7a8;
      }
      .btn-yellow {
        background: #f7b500;
      }
      .btn-orange {
        background: #fa6400;
      }
    }
  }
}
#searchSection {
  .switch-tab {
    > div {
      display: inline-block;
      padding: 5px;
      border: 1px solid #ccc;
      cursor: pointer;
      font-size: 14px;
      box-sizing: border-box;
      &:nth-child(2) {
        border-right: none;
        border-left: none;
      }
    }
    > div.active {
      border-bottom: 2px solid #2f7bee;
    }
  }
}
.progress-time {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.progress-bg {
  width: 300px;
  background-color: #ddd;
  border-radius: 5px;
  margin-right: 20px;
  overflow: hidden;
}
.skills {
  text-align: right;
  padding-right: 20px;
  line-height: 20px;
  color: white;
}
.progress {
  width: 10%;
  height: 20px;
  background-color: #4caf50;
}
.c-content #search,
.c-content #wSearch {
  padding: 10px 0;
}
#uList {
  padding-top: 50px;
  margin-bottom: 10px;
}
tr {
  td {
    &:first-child {
      width: 500px;
    }
  }
}
</style>
